<template>
    <div>
        <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
            <div class="items-center md:flex">
                <img class="w-full mb-3 md:w-auto md:h-32" src="https://disticloudfiles.net/img/savinfo/default/no_process.webp" alt="">
                <div class="ml-3">
                    <div class="my-2 text-lg font-semibold" test-id="label-no-process" v-html="$tt(texte)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'no-process',
    extends: FormCardExtension,

    data() {
        return {
            texte: null,
        }
    },

    methods: {
        async init() {
            let setCaseData = this.$formTool.getFormData('set-case')
            if (setCaseData) {
                let text = await apiService.text('no_process', this.$formTool.getFormData('proc').id, JSON.parse(setCaseData).id_case)
                if (text) {
                    this.texte = text
                } else {
                    this.$parent.removeLastBlock()
                }
            }  else {
                this.texte = this.$t('form.aucun_process.aucune_procedure_a_completer')
            }

            // Check if data
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            this.emitChange()
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/NoProcessCard.vue